import { isEmpty } from "lodash"
import { guidEmpty } from "./guid-empty"

export const isEmptyOrGuid = (value: any) => {
    return isEmpty(value) || value === guidEmpty();
}